import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=d7412dbe&scoped=true&lang=pug"
import script from "./MessageCenter.vue?vue&type=script&lang=ts"
export * from "./MessageCenter.vue?vue&type=script&lang=ts"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=d7412dbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7412dbe",
  null
  
)

export default component.exports